import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { track } from "@/lib/track";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 420);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (pathname.startsWith("/franchise") || pathname.startsWith("/admin")) return null;

  return (
    <div
      data-testid="mobile-sticky-franchise-cta"
      className={`fixed inset-x-0 bottom-0 z-50 border-t border-deep/10 bg-cream/95 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 backdrop-blur-md transition-transform duration-500 md:hidden ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <Link
        to="/franchise#franchise-form"
        data-testid="sticky-own-a-rific-btn"
        onClick={() => track("franchise_cta_click", { placement: "sticky_mobile" })}
        className="flex h-12 w-full items-center justify-center gap-2 rounded-full bg-orange-rific font-body text-sm font-bold uppercase tracking-[0.16em] text-white"
      >
        Own a RIFIC
        <ArrowUpRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
